// TYPES
var simulationTypes = { medicalCare: { value: 'Consultation', code: 'C' }, 
    dentalCare: { value: 'Dentaire', code: 'D'}, 
    opticalCare: { value: 'Optique', code: 'O'}, 
    hospitalization: { value: 'Hospitalisation', code: 'H'}}
var medicalCareTypes = { generalPractitioner: { value: 'Généraliste', code: 'G'}, 
    specialist: { value: 'Spécialiste', code: 'S'}, 
    cardiologist: { value: 'Cardiologue', code: 'CA'}, 
    neuropsychiatrist: { value: 'Neuropsychiatre', code: 'NPS'}, 
    osteopath: { value: 'Ostéopathe', code: 'OS'}, 
    chiropractor: { value: 'Chiropracteur', code: 'CH'}}
var hospitalizationTypes = { hospitalRoom: { value: 'Chambre particulière - hors maternité', code: 'CPHM'},
    hospitalRoomForPregnancy: { value: 'Chambre particulière maternité ', code: 'CPM'},
    accompagnyingBed: { value: 'Lit accompagnant', code: 'LA'}}
var OPTAMTypes = { OPTAM: { value: 'OPTAM', code: 'O'}, nonOPTAM: { value: 'Non OPTAM', code: 'N'}}
var dentalCareTypes = { Crown: { value: 'Couronne', code: 'C'}, AdultOrthodontics: { value: 'Orthodontie Adulte et Enfant + 16 ans', code: 'OA'}, ChilrenOrthodontics: { value: 'Orthodontie Enfant - 16 ans', code: 'OE'}}
var adultChildTypes = { Adult: { value: 'Adulte', code: 'A'}, Child: { value: 'Enfant', code: 'E'}}
var refundTypes = { Refunded: { value: 'Acceptée', code: 'A'}, NotRefunded: { value: 'Refusée', code: 'R'}}
var opticalTypes = { Lens: { value: 'Lentilles de contact non remboursées par la Sécurité Sociale', code: 'L'}, Glasses: { value: 'Equipement optique', code: 'EO'}}
var glassTypes = { Simple: { value: 'Simple', code: 'S'}, Average: { value: 'Moyen', code: 'M'}, Complex: { value: 'Complexe', code: 'C'}}

// Get code functions
medicalCareTypes.getCode = function(value) { return value == this.generalPractitioner.value ? this.generalPractitioner.code : 
    (value == this.specialist.value ? this.specialist.code : 
    (value == this.cardiologist.value ? this.cardiologist.code : 
    (value == this.neuropsychiatrist.value ? this.neuropsychiatrist.code : 
    (value == this.osteopath.value ? this.osteopath.code : this.chiropractor.code)))) }
hospitalizationTypes.getCode = function(value) { return value == this.hospitalRoom.value ? this.hospitalRoom.code : 
    (value == this.accompagnyingBed.value ? this.accompagnyingBed.code : this.hospitalRoomForPregnancy.code) }
OPTAMTypes.getCode = function(value) { return value == this.OPTAM.value ? this.OPTAM.code : this.nonOPTAM.code }
dentalCareTypes.getCode = function(value) { return value == this.AdultOrthodontics.value ? this.AdultOrthodontics.code : 
    (value == this.ChilrenOrthodontics.value ? this.ChilrenOrthodontics.code : this.Crown.code) }
adultChildTypes.getCode = function(value) { return value == this.Adult.value ? this.Adult.code : this.Child.code }
refundTypes.getCode = function(value) { return value == this.Refunded.value ? this.Refunded.code : this.NotRefunded.code }
opticalTypes.getCode = function(value) { return value == this.Glasses.value ? this.Glasses.code : this.Lens.code }
glassTypes.getCode = function(value) { return value == this.Simple.value ? this.Simple.code : (value == this.Average.value ? this.Average.code : this.Complex.code)}
simulationTypes.getCode = function(value) {
    if (value == this.medicalCare.value) return this.medicalCare.code 
    if (value == this.dentalCare.value) return this.dentalCare.code 
    if (value == this.opticalCare.value) return this.opticalCare.code 
    if (value == this.hospitalization.value) return this.hospitalization.code 
}

// Freeze objects
simulationTypes = Object.freeze(simulationTypes)
medicalCareTypes = Object.freeze(medicalCareTypes)
hospitalizationTypes = Object.freeze(hospitalizationTypes)
OPTAMTypes = Object.freeze(OPTAMTypes)
dentalCareTypes = Object.freeze(dentalCareTypes)
adultChildTypes = Object.freeze(adultChildTypes)
refundTypes = Object.freeze(refundTypes)
opticalTypes = Object.freeze(opticalTypes)
glassTypes = Object.freeze(glassTypes)

export { simulationTypes, medicalCareTypes, hospitalizationTypes, OPTAMTypes, dentalCareTypes, adultChildTypes, refundTypes, opticalTypes, glassTypes }


// WEBPACK FOOTER //
// ./src/helpers/types.js